import * as yup from 'yup';
import { getYoutubeId } from '../../../utils/getYoutubeId';

/**
 * Verifica si una cadena es una URL válida.
 * @param {string} str - La cadena a validar como URL.
 * @returns {boolean} - `true` si la cadena es una URL válida, `false` en caso contrario.
 */
const isValidURL = str => {
  try {
    new URL(str); // Intenta crear un objeto URL con la cadena dada
    return true; // Si no lanza un error, la URL es válida
  } catch {
    return false; // Si se lanza un error, la URL no es válida
  }
};

/**
 * Valida que un video de YouTube no esté duplicado en la lista de videos existentes.
 * @param {string} value - La URL del video de YouTube a validar.
 * @returns {boolean} - `true` si el video es único o si no hay valor, `false` si ya existe.
 */
const validateUniqueVideo = function(value) {
  if (!value) return true; // Si no hay valor, no se valida y retorna `true`.

  const videoId = getYoutubeId(value); // Obtiene el ID del video de YouTube
  if (!videoId) return false; // Si no se puede extraer el ID, la URL no es válida.

  const actualVideos = this.options.context.videos; // Obtiene la lista de videos actuales
  const existingVideo = actualVideos.find(e => e.key_video === videoId);

  return !existingVideo; // Retorna `true` si el video no existe en la lista, `false` si ya existe.
};

const videosSchema = yup.object().shape({
  videoUrl: yup
    .string()
    .notRequired()
    .when('$validateVideo', {
      is: false,
      then: schema => schema.transform(() => '')
    })
    .test('matches', 'VideoId inválido', value => !value || getYoutubeId(value))
    .test('existInArray', 'Ya existe en el array', validateUniqueVideo),
  video360: yup
    .string()
    .notRequired()
    .when('$validate360', {
      is: false,
      then: schema => schema.transform(() => '')
    })
    .test('checkBasicUrl', 'URL inválida', function(value) {
      return !value || isValidURL(value);
    })
});

const formSchema = yup.object().shape({
  pictures: yup
    .array()
    .min(5, 'professionalPubli.multimedia.image.errorLimitMin')
    .max(50, 'professionalPubli.multimedia.image.errorLimitMax'),
  videos: yup
    .array()
    .max(10, 'professionalPubli.multimedia.video.errorLimitMax')
    .nullable()
    .notRequired(),
  tour360: yup
    .array()
    .max(1, 'professionalPubli.multimedia.video360.errorLimitMax')
    .nullable()
    .notRequired(),
  plans: yup
    .array()
    .max(50, 'professionalPubli.multimedia.plans.errorLimitMax')
    .nullable()
    .notRequired()
});

export { formSchema, videosSchema };
